const $ = require("jquery");
$('a[href^="tel:"]').click(function () {
	gtag('event', 'phone', {
		//'event_label': 'phone',
		'event_category': 'contact',
	});
	//fbq('track', 'Lead phone');
});

$('a[href^="mailto:"]').click(function(){
	gtag('event', 'email', {
		//'event_label': 'email',
		'event_category': 'contact',
	});
	//fbq('track', 'Lead email');
});

// request / form_submit считаются по загрузке form_* / success_* (см. config.php)
/*$('.form-first-check').submit(function(){
	gtag('event', 'request', {
		//'event_label': 'Form',
		'event_category': 'conversion',
	});
});*/

// request / form_submit считаются по загрузке form_* / success_* (см. config.php)
/*$('.form-lead').submit(function(){
	gtag('event', 'form_submit', {
		//'event_label': 'Form',
		'event_category': 'conversion',
	});
});*/

require('./app.js');
require('./validation.js');
require('slick-carousel');
//require('./timer.js');


$('#reviews .items').slick({
	centerMode: true,
	slidesToShow: 3,
	arrows: false,
	prevArrow: $('#reviews .prev'),
	nextArrow: $('#reviews .next'),
	zIndex: 500,
	variableWidth: true,
	swipeToSlide: true,
	autoplay: true,
	autoplaySpeed: 5000,
});

$('.prev_next').on('click', function(event) {
	event.preventDefault();
	$siblings = $(this).siblings('.slick-slider');
	if ($(this).hasClass('next')) { $siblings.slick('slickNext'); }
	if ($(this).hasClass('prev')) { $siblings.slick('slickPrev'); }
});

$('form [name="defect"]').on('change load', function(event) {
	var $this = $(this),
		$form = $this.closest('form'),
		$textarea = $form.find('.other_deffect');
	if ($this.val() === 'Другое') {
		$textarea.removeClass('hide');
	} else {
		$textarea.addClass('hide');
	}
});

/*$('.timer').timer({
    eachnumberspan: true,
    enddate: moment().tz('Europe/Riga').endOf('day'),
    usemoment: true,
    childelement: '.atimer'
});*/

/*$(document).ready(function () {
	let $url_link = window.location.href;

	if($url_link === 'https://lp.aboluserviss.lv/iphone/success_ru.php' || $url_link === 'https://lp.aboluserviss.lv/iphone/success_lv.php') {
		gtag('event', 'form_submit', {
			//'event_label': 'Form',
			'event_category': 'conversion',
		});
		//fbq('trackCustom', 'Lead form');
	}
});*/
